/* global window appData */

import Vue from 'vue';
import $ from 'jquery';
import { mapState } from 'vuex';


// Mixins
import { RestComponent } from '../../../mixins/rest-component';
import { CaseListing } from '../../../mixins/case-listing';

// Template and media files
import template from '../shared-template/page-listing-overview.vhtml';
import logo from '../../../../_img/logo-esbjerghavn.svg';
import arrowBtn from '../../../../_img/icons/arrow-btn.svg';
import Userbar from '../../userbar/userbar'


export const PagePublicListingOverview = Vue.component('page-public-listing-overview', {
	components: {
		logo,
		arrowBtn,
		Userbar
	},
	mixins: [RestComponent, CaseListing],
	template: template,
	props: {
		appLoaded: {
			type: Boolean,
			default: false,
		},
	},
	data: () => ({
		containerWidth: 0,
		hideMoreThan300: false,
		hideMoreThan500: false,
		hideLogo: false,
		mailingList: true,
		userCreate: false,
		showValueChains: false,
		valuechain: '',
		isLoggedIn: appData.user.isLoggedIn,
		options: [
			{
				value: "deadline",
				label: "Sort by deadline"
			},
			{
				value: "title",
				label: "Sort by name"
			},
			{
				value: "created",
				label: "Sort by created"
			}
		]
	}),
	computed: {
		website: vm => vm.$store.state.appsData.data.website,
		...mapState({
			website: state => state.appsData.data.website,
			showLogo: state => state.content.showLogo,
			isNavigating: state => state.pages.isNavigating,
		}),
		showeula: function () {
			return false;
		},
		reduce: function () {
			return label => label.value
		}
	},
	watch: {
		content() {
			this.$store.commit('sidebar/updateData', {
				name: 'parent',
				value: this.content.parent,
			});
		}
	},
	created() {
		this.$store.dispatch('pages/setScrollPosition');
		this.$store.dispatch('pagination/makeFullScreen');
		this.$store.commit('pagination/updateData', {
			name: 'outOfViewPos',
			value: '',
		});
		this.$store.commit('pagination/updateData', {
			name: 'fullWidthUntilLg',
			value: true,
		});
		this.$store.commit('pagination/updateData', {
			name: 'fullWidthUntilLg',
			value: true,
		});
	},
	mounted() {
	},
	beforeDestroy() {
	},
	methods: {
		toogleScrollElements(e) {
			e.target.scrollTop > 50 ? this.hideLogo = true : this.hideLogo = false;
		},
		navigateToIndex(link) {
			window.removeEventListener('scroll', this.$options.throttleFunction);
			this.$store.commit('sidebar/updateData', {
				name: 'transparentUntilLg',
				value: false,
			});
			this.$store.commit('sidebar/updateData', {
				name: 'stuckToTopMobile',
				value: false,
			});
			this.navigateLeft(link);
			setTimeout(() => {
				this.$store.commit('sidebar/updateData', {
					name: 'sidebarPos',
					value: 'left',
				});
			}, 100);
		},
	}
});



// WEBPACK FOOTER //
// ./assets/_js/components/post-types/page-public-listing-overview/page-public-listing-overview.js